export enum Environment {
  Production = 'production',
  Candidate = 'candidate',
  UAT = 'uat',
  EU = 'eu',
  Main = 'main',
}

const baseUrls = {
  [Environment.Production]: `https://prostudio.pypestream.com`,
  [Environment.EU]: `https://prostudio.pypestream.eu`,
  [Environment.Candidate]: `https://prostudio.candidate.pypestream.dev`,
  [Environment.Main]: `https://prostudio.main.pypestream.dev`,
  [Environment.UAT]: `https://prostudio.uat.pypestream.dev`,
};

export const getEnvironmentFromUrl = (url: string): Environment | null => {
  return (
    (Object.entries(baseUrls).find(([, baseUrl]) =>
      url.startsWith(baseUrl)
    )?.[0] as Environment) || null
  );
};

export const getLauncherUrls = (origin: string) => {
  const env = getEnvironmentFromUrl(origin) || Environment.Main;

  const baseUrl = env === Environment.Production ? '' : `${env}.`;
  const topLevelDomain = env === Environment.Production ? 'com' : 'dev';

  return {
    live: `https://web.${baseUrl}pypestream.${topLevelDomain}`,
    sandbox: `https://web-sandbox.${baseUrl}pypestream.${topLevelDomain}`,
  };
};
